"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadLocaleDayjs = exports.dayjsLocaleLoaders = exports.dayjsLocales = exports.DEFAULT_DAYJS_LANG = void 0;
const lang_1 = require("../lang");
const constants_1 = require("../../constants");
const dayjsCore_1 = require("./dayjsCore");
exports.DEFAULT_DAYJS_LANG = constants_1.Languages.RU;
exports.dayjsLocales = {
    ru: 'ru',
    en: 'en',
    cn: 'zh',
    uz: 'uz-latn',
    kz: 'kk',
    zh: 'zh',
};
exports.dayjsLocaleLoaders = {
    ru: Promise.resolve().then(() => __importStar(require(`dayjs/locale/ru.js`))),
    en: Promise.resolve().then(() => __importStar(require(`dayjs/locale/en.js`))),
    cn: Promise.resolve().then(() => __importStar(require(`dayjs/locale/zh.js`))),
    uz: Promise.resolve().then(() => __importStar(require(`dayjs/locale/uz-latn.js`))),
    kz: Promise.resolve().then(() => __importStar(require(`dayjs/locale/kk.js`))),
    zh: Promise.resolve().then(() => __importStar(require(`dayjs/locale/zh.js`))),
};
const loadLocaleDayjs = async () => {
    const language = (0, lang_1.getCurrentLng)();
    try {
        console.debug(`Load locale for a language code ${language}`);
        const loadLocale = exports.dayjsLocaleLoaders[language];
        const localeName = exports.dayjsLocales[language];
        await loadLocale;
        dayjsCore_1.dayjsCore.locale(localeName);
    }
    catch (e) {
        console.error(`Couldn't load locale for code ${language}. Available language list: ${constants_1.languagesList}`);
        dayjsCore_1.dayjsCore.locale(exports.dayjsLocales[exports.DEFAULT_DAYJS_LANG]);
    }
};
exports.loadLocaleDayjs = loadLocaleDayjs;
//# sourceMappingURL=loadLocaleDayjs.js.map